import React from 'react';
import './UIFooter.css';
import logo from "../../../../assets/logo.webp";

function navigate(path) {
    window.history.pushState(null, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
}

export default function UIFooter() {
    return (
        <footer className="ui-footer">
            <div className="ui-footer-inner">
                <div className="ui-footer-brand">
                    <img src={logo} alt="Dorffuchs Logo" />
                    <span>dorffuchs</span>
                </div>
                <nav className="ui-footer-links">
                    <a href="/impressum"   onClick={e => { e.preventDefault(); navigate('/impressum');   }}>Impressum :: Datenschutz :: AGB</a>
                    {/*<a href="/datenschutz" onClick={e => { e.preventDefault(); navigate('/datenschutz'); }}>Datenschutz</a>*/}
                    {/*<a href="/agb"         onClick={e => { e.preventDefault(); navigate('/agb');         }}>AGB</a>*/}
                    {/*<a href="/contact"     onClick={e => { e.preventDefault(); navigate('/contact');     }}>Kontakt</a>*/}
                </nav>
                <p className="ui-footer-cookies"> Wir verwenden keine Cookies </p>
                <p className="ui-footer-copy">© {new Date().getFullYear()} Dorffuchs.</p>
            </div>
        </footer>
    );
}

